import React, { useCallback } from "react";
import MainAppBar from "../components/MuiComponents/MainAppBar";
import CanvasLayout from "../components/MuiComponents/CanvasLayout";
import ActionsDrawer from "../components/ActionsDrawer";
import { useEmotionState } from "./useEmotionState";

function ClientMui() {
  const { isGifSaved, setIsGifSaved, options, setOptions } = useEmotionState();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = useCallback((newOpen) => {
    setOpen(newOpen);
  }, []);

  return (
    <>
      <MainAppBar toggleDrawer={toggleDrawer} />
      <ActionsDrawer
        isOpen={open}
        toggleDrawer={toggleDrawer}
        setIsGifSaved={setIsGifSaved}
      />
      <CanvasLayout
        isGifSaved={isGifSaved}
        setIsGifSaved={setIsGifSaved}
        options={options}
        setOptions={setOptions}
      />
    </>
  );
}

export default ClientMui;
